import Vue from 'vue';
Vue.directive('clicklog', {
    inserted(el, binding) {
        el.onclick = () => {
            const param = binding.value;
            if (window.clickLog) {
                window.clickLog(`from=${param}`);
                console.log(param);
            }
        };
    }
});
